import { Box } from "@mui/material";
import LineChart from "../../../../components/LineChart";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Line = () => {
  return (
    <DashboardLayout>
      <Box m="20px">
        <DashboardHeader title="Line Chart" subtitle="Simple Line Chart" />
        <Box height="70vh">
          <LineChart />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Line;
